import { Flex, Heading, Stack, Text, useColorModeValue as mode } from '@chakra-ui/react'
import * as React from 'react';
import Number from "components/number-format";

type OrderSummaryItemProps = {
    label: string
    value?: number
    children?: React.ReactNode
}

const OrderSummaryItem = (props: OrderSummaryItemProps) => {
    const { label, value, children } = props
    return (
        <Flex justify="space-between" fontSize="sm">
            <Text fontWeight="medium" color={mode('gray.600', 'gray.400')}>
                {label}
            </Text>
            {
                value ?
                    <Text fontWeight="medium">
                        <Number displayType={"text"} prefix={"Rp "} value={value} />
                    </Text>
                    :
                    children
            }
        </Flex>
    )
}

interface OrderSummaryProps {
    order: any
}

export const OrderSummary: React.FC<OrderSummaryProps> = ({ order }) => {

    return (
        <Stack spacing="8" borderWidth="1px" rounded="lg" padding="8" width="full">
            <Heading size="md">Order Summary</Heading>
            <Stack spacing="6">
                <OrderSummaryItem label="Subtotal" value={order.subTotal} />
                <OrderSummaryItem label="Ongkos Kirim">
                    <Number displayType={"text"} prefix={"Rp "} value={order.totalShippingCost} />
                </OrderSummaryItem>
                <OrderSummaryItem label="Diskon">
                    -
                </OrderSummaryItem>
                <Flex justify="space-between">
                    <Text fontSize="lg" fontWeight="semibold">
                        Total
                    </Text>
                    <Text fontSize="xl" fontWeight="extrabold">
                        <Number displayType={"text"} prefix={"Rp "} value={order.netTotal} />
                    </Text>
                </Flex>

                <OrderSummaryItem label="Metode Pembayaran">
                    <Text fontWeight={'semibold'}>{order.paymentMethodString}</Text>
                </OrderSummaryItem>
            </Stack>
        </Stack>
    )
}